import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    interval: { type: Number, default: 10000 },
    count: { type: Number, default: 10 }
  }

  connect() {
    // Always start with bg1
    this.currentIndex = 1
    this.preloadedImages = new Set([1]) // Track which images we've preloaded
    this.nextImageIndex = null // Store the next image to show

    // Set initial background immediately
    this.element.style.backgroundImage = `url('/img/bg${this.currentIndex}.jpg')`
    this.element.style.backgroundSize = 'cover'
    this.element.style.backgroundPosition = 'center'
    this.element.style.backgroundAttachment = 'fixed'
    this.element.style.backgroundRepeat = 'no-repeat'

    // Preload the next image
    this.preloadNextImage()

    // Start cycling after a delay
    setTimeout(() => {
      this.setupCycling()
      this.startCycling()
    }, 100)
  }

  preloadNextImage() {
    // Pick a random index different from the current one
    let newIndex
    do {
      newIndex = Math.floor(Math.random() * this.countValue) + 1
    } while (newIndex === this.currentIndex && this.countValue > 1)

    this.nextImageIndex = newIndex

    // Preload only if we haven't already
    if (!this.preloadedImages.has(newIndex)) {
      const img = new Image()
      img.src = `/img/bg${newIndex}.jpg`
      this.preloadedImages.add(newIndex)
    }
  }

  disconnect() {
    if (this.intervalId) {
      clearInterval(this.intervalId)
    }
  }

  setupCycling() {
    // Create two div layers for crossfading
    this.bg1 = document.createElement('div')
    this.bg1.style.cssText = `
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-image: url('/img/bg${this.currentIndex}.jpg');
      background-size: cover;
      background-position: center;
      background-attachment: fixed;
      background-repeat: no-repeat;
      transition: opacity 2s ease-in-out;
      z-index: 0;
      opacity: 1;
      pointer-events: none;
    `

    this.bg2 = document.createElement('div')
    this.bg2.style.cssText = `
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-size: cover;
      background-position: center;
      background-attachment: fixed;
      background-repeat: no-repeat;
      transition: opacity 2s ease-in-out;
      opacity: 0;
      z-index: 0;
      pointer-events: none;
    `

    // Insert background layers before content
    this.element.insertBefore(this.bg2, this.element.firstChild)
    this.element.insertBefore(this.bg1, this.element.firstChild)

    // Make sure content is above backgrounds
    Array.from(this.element.children).forEach((child, index) => {
      if (index > 1) { // Skip the two background divs we just added
        child.style.position = 'relative'
        child.style.zIndex = '1'
      }
    })
  }

  startCycling() {
    this.intervalId = setInterval(() => {
      this.nextBackground()
    }, this.intervalValue)
  }

  nextBackground() {
    // Use the preloaded next image
    this.currentIndex = this.nextImageIndex

    // Mark this image as used
    this.preloadedImages.add(this.currentIndex)

    // Determine which layer is currently visible
    const isFirstLayerVisible = parseFloat(this.bg1.style.opacity) !== 0

    if (isFirstLayerVisible) {
      // Load new image in bg2 and fade it in
      this.bg2.style.backgroundImage = `url('/img/bg${this.currentIndex}.jpg')`
      this.bg2.style.opacity = '1'
      this.bg1.style.opacity = '0'
    } else {
      // Load new image in bg1 and fade it in
      this.bg1.style.backgroundImage = `url('/img/bg${this.currentIndex}.jpg')`
      this.bg1.style.opacity = '1'
      this.bg2.style.opacity = '0'
    }

    // Immediately preload the next image after starting this transition
    this.preloadNextImage()
  }
}

